import {Empty, Spin} from "antd";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import style from "../style/Gsc.module.scss";

const cn = className.bind(style);

/** Loại tìm kiếm khác web mà GSC theo dõi (image/video/news) → nhãn + icon. */
const TYPE_META = {
	image:      {label: 'Tìm kiếm hình ảnh', icon: 'fa-light fa-image'},
	video:      {label: 'Tìm kiếm video', icon: 'fa-light fa-clapperboard'},
	news:       {label: 'Tin tức', icon: 'fa-light fa-newspaper'},
	discover:   {label: 'Discover', icon: 'fa-light fa-compass'},
	googleNews: {label: 'Google Tin tức', icon: 'fa-light fa-newspaper'},
};

const fmt = (n) => Number(n || 0).toLocaleString('vi-VN');

/**
 * Khối "Các nguồn lưu lượng khác": lưu lượng theo loại tìm kiếm ngoài web.
 * rows: [{type: 'image', clicks, impressions}].
 */
function GscSearchTypes({rows = [], loading = false}) {

	if (loading) {
		return <div style={{textAlign: 'center', padding: '30px 0'}}><Spin /></div>;
	}

	if (!rows.length) {
		return <Empty description="Không có lưu lượng từ nguồn nào khác (hình ảnh, video, tin tức)." image={Empty.PRESENTED_IMAGE_SIMPLE} />;
	}

	return (
		<div className={cn('sourceList')}>
			{rows.map((r) => {
				const meta = TYPE_META[r.type] || {label: r.type, icon: 'fa-light fa-magnifying-glass'};

				return (
					<div key={r.type} className={cn('sourceRow')}>
						<div className={cn('sourceName')}>
							<FontAwesomeIcon icon={meta.icon} /> {meta.label}
						</div>
						<div className={cn('sourceMeta')}>
							<span><b>{fmt(r.clicks)}</b> clicks</span>
							<span className={cn('sourceImpr')}>{fmt(r.impressions)} hiển thị</span>
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default GscSearchTypes;
